"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountDownBanner = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CountDownTypography = function CountDownTypography(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      fontFamily: "DS-DIGI",
      fontSize: "1.5rem",
      marginX: "1rem",
      display: "grid",
      placeItems: "center",
      lineHeight: 1
    }
  }, children);
};
var CountDownBanner = exports.CountDownBanner = function CountDownBanner(_ref2) {
  var _ref2$inputSeconds = _ref2.inputSeconds,
    inputSeconds = _ref2$inputSeconds === void 0 ? 10 : _ref2$inputSeconds;
  var initialTime = inputSeconds;
  var _useState = (0, _react.useState)(inputSeconds),
    _useState2 = _slicedToArray(_useState, 2),
    seconds = _useState2[0],
    setSeconds = _useState2[1];
  var duration = _moment["default"].duration(seconds, 'seconds');
  var hours = Math.floor(duration.asHours());
  var minutes = duration.minutes();
  var secs = duration.seconds();
  (0, _react.useEffect)(function () {
    var intervalId = setInterval(function () {
      setSeconds(function (prev) {
        if (prev <= 0) {
          return initialTime; // restart the timer
        } else {
          return prev - 1;
        }
      });
    }, 1000);
    return function () {
      clearInterval(intervalId);
    };
  }, [initialTime]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100vw",
      height: "3.75rem",
      display: "flex",
      flexDirection: "row",
      padding: "1rem",
      background: "linear-gradient(to right, #B9F, #7249F5)",
      justifyContent: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      color: "white",
      textAlign: "center",
      fontFamily: 'Gilroy',
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "120%",
      /* 14.4px */
      display: "grid",
      placeItems: "center",
      marginRight: "2rem"
    }
  }, "Special Deal Ending in"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/_react["default"].createElement(CountDownTypography, null, String(hours).padStart(2, '0')), /*#__PURE__*/_react["default"].createElement(CountDownTypography, null, ":"), /*#__PURE__*/_react["default"].createElement(CountDownTypography, null, String(minutes).padStart(2, '0')), /*#__PURE__*/_react["default"].createElement(CountDownTypography, null, ":"), /*#__PURE__*/_react["default"].createElement(CountDownTypography, null, String(secs).padStart(2, '0'))));
};